module.exports = __webpack_public_path__ + "static/media/like.9d0356f6.svg";